import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubjectViewQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type SubjectViewQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, description?: string | null, hidden: boolean, banner?: string | null, domain: string, group?: string | null, urlSlug: string, logoImageUrl?: string | null, userHasAccess?: boolean | null, hasAccessViaSubscription?: boolean | null, countOfQuestions?: number | null, countOfFreeResponseQuestions?: number | null, subscriptionsPrices?: Array<any> | null, curriculumArea?: { __typename?: 'CurriculumArea', name: string } | null, guides: Array<{ __typename?: 'Guide', id: string, type: string }>, subjectFaqs: Array<{ __typename?: 'SubjectFaq', id: string }> }> | null } | null };


export const SubjectViewDocument = gql`
    query SubjectView($slug: String!) {
  subjects(filter: {urlSlug: {eq: $slug}, adaptive: {eq: false}}, first: 1) {
    results {
      id
      name
      description
      hidden
      banner
      domain
      group
      urlSlug
      logoImageUrl
      userHasAccess
      hasAccessViaSubscription
      countOfQuestions
      countOfFreeResponseQuestions
      subscriptionsPrices
      curriculumArea {
        name
      }
      guides(filter: {published: {eq: true}}) {
        id
        type
      }
      subjectFaqs {
        id
      }
    }
  }
}
    `;

/**
 * __useSubjectViewQuery__
 *
 * To run a query within a React component, call `useSubjectViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectViewQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSubjectViewQuery(baseOptions: Apollo.QueryHookOptions<SubjectViewQuery, SubjectViewQueryVariables> & ({ variables: SubjectViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectViewQuery, SubjectViewQueryVariables>(SubjectViewDocument, options);
      }
export function useSubjectViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectViewQuery, SubjectViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectViewQuery, SubjectViewQueryVariables>(SubjectViewDocument, options);
        }
// @ts-ignore
export function useSubjectViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectViewQuery, SubjectViewQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectViewQuery, SubjectViewQueryVariables>;
export function useSubjectViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectViewQuery, SubjectViewQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectViewQuery | undefined, SubjectViewQueryVariables>;
export function useSubjectViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectViewQuery, SubjectViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectViewQuery, SubjectViewQueryVariables>(SubjectViewDocument, options);
        }
export type SubjectViewQueryHookResult = ReturnType<typeof useSubjectViewQuery>;
export type SubjectViewLazyQueryHookResult = ReturnType<typeof useSubjectViewLazyQuery>;
export type SubjectViewSuspenseQueryHookResult = ReturnType<typeof useSubjectViewSuspenseQuery>;
export type SubjectViewQueryResult = Apollo.QueryResult<SubjectViewQuery, SubjectViewQueryVariables>;